import React from "react";
import { ExternalLink } from "lucide-react";

export default function FinishingSolution() {
  return (
    <section
      data-testid="finishing-solution-section"
      className="relative bg-navy text-white py-24 md:py-32 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
          backgroundSize: "64px 64px",
        }}
      />
      <div className="absolute -top-32 -right-32 w-96 h-96 bg-teal/20 rounded-full blur-3xl" />

      <div className="relative max-w-5xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
          The solution
        </div>
        <h2
          data-testid="finishing-solution-headline"
          className="font-serif text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-black tracking-tight text-white leading-[1.1]"
        >
          Complete Your{" "}
          <span className="text-teal">In-House Print System.</span>
        </h2>
        <p className="mt-8 text-lg sm:text-xl text-slate-300 leading-relaxed max-w-3xl">
          With the right finishing tools, your school can go from printing… to
          producing.
        </p>

        <div className="mt-10 flex items-center gap-6 text-2xl sm:text-3xl font-serif font-bold">
          <span className="text-slate-400 line-through decoration-2">Printing</span>
          <ExternalLink className="w-7 h-7 text-teal" strokeWidth={2.5} />
          <span className="text-teal">Producing</span>
        </div>

        <p className="mt-12 text-base sm:text-lg text-slate-200 max-w-3xl leading-relaxed border-l-4 border-teal pl-6 italic">
          Create polished, durable, professional-quality materials entirely in-house.
        </p>
      </div>
    </section>
  );
}
